import Textarea from "@hudson/ui/components/FormFields/Textarea";
import Field from "@hudson/ui/components/FormFields/Field";

function Directions({
  fieldName,
  label,
}: {
  fieldName: string;
  label: string;
}): JSX.Element | null {
  return (
    <Field
      fieldControl={(value, onChange, _, onBlur) => (
        <Textarea className="w-full" onBlur={onBlur} onChange={onChange} value={value} />
      )}
      fieldName={fieldName}
      label={label}
    />
  );
}

export default Directions;
